import './cta-small.scss';
